

interface IPartC {
    /**
     * Property bag to contain additional custom properties (Part C)
     */
    properties?: { [key: string]: any };
}
interface IEventTelemetry extends IPartC {
    /**
     * @description An event name string
     * @type {string}
     * @memberof IEventTelemetry
     */
    name: string;

    /**
     * @description custom defined iKey
     * @type {string}
     * @memberof IEventTelemetry
     */
    iKey?: string;
}
interface AppInsight {
    trackEvent(event: IEventTelemetry, customProperties?: { [key: string]: any }): void;
}

declare global {
    interface Window {
        appInsights?: AppInsight;
    }
}

export interface IGamePlanMetrics {
    trackEvent(name: string, properties?: { [key: string]: any }): void;
}

type EventProperties = { [key: string]: any };

class GamePlanMetrics implements IGamePlanMetrics {
    trackEvent(name: string, propertiesOrFunc?: EventProperties | (() => EventProperties)): void {
        if (window && window.appInsights && window.appInsights.trackEvent) {
            if (typeof propertiesOrFunc === 'function') {
                try {
                    window.appInsights.trackEvent({ name }, propertiesOrFunc());

                } catch (err) {

                }
            } else if (typeof propertiesOrFunc !== 'undefined') {
                window.appInsights.trackEvent({ name }, propertiesOrFunc);
            }
        }
    }
}

const globalMetrics = new GamePlanMetrics();

export function gpMetrics() {
    return globalMetrics;
}
